export const USER_PERMISSIONS = {
  DASHBOARD: ['dashboard'],
  PROMOTION: ['promotion'],

  ORDERS_CREATE: ['orders:create'],
  ORDERS_EDIT: ['orders:edit'],
  ORDERS_VIEW: ['orders:edit', 'orders:view'],
  ORDERS_MANAGMENT: ['orders:management'],
  ORDERS_CANCEL: ['orders:cancel'],
  ORDERS_DELIVERY: ['orders:delivery'],

  // WAITLIST: ['waitlist'],

  ITEMS_IN_BRANCH_STOCK_EDIT: ['branch_items:edit_stock'],
  ITEMS_IN_BRANCH_STATUS_EDIT: ['branch_items:edit_status'],
  ITEMS_GLOBAL_STOCK_EDIT: ['products:edit_stock'],
  ITEMS_GLOBAL_STATUS_EDIT: ['products:edit_status'],

  BRANCH_ITEMS_VIEW: ['branch_items:view'],
  BRANCH_BUSY_MODE: ['set_branch_to_busy_mode'],

  REPORTS: ['reports'],

  CUSTOMERS: ['customers'],
  CUSTOMERS_VIEW: ['customers:view'],
};

export const USER_ROLES = {
  CASHIER: 'cashier',
  MARKETING: 'marketing',
  RESTAURANT_MANAGER: 'restaurant_manager',
  CUSOMER_CARE: 'customer_care',
  CALL_CENTER_AGENT: 'call_center_agent',
  OPERATOR: 'operator',
  ACCOUNTING: 'accounting',
  FRANCHISEE: 'franchisee',
  FOODICS_PARTNER: 'foodics_partner',
};

/**
 * all roles, except CALL_CENTER
 */
export const orderScreenRoles: string[] = [
  USER_ROLES.RESTAURANT_MANAGER,
  USER_ROLES.CASHIER,
  USER_ROLES.MARKETING,
  USER_ROLES.ACCOUNTING,
  USER_ROLES.CUSOMER_CARE,
  USER_ROLES.FRANCHISEE,
  USER_ROLES.OPERATOR,
];
export const orderHistoryScreenRoles: string[] = [
  USER_ROLES.RESTAURANT_MANAGER,
  USER_ROLES.MARKETING,
  USER_ROLES.ACCOUNTING,
  USER_ROLES.CUSOMER_CARE,
  USER_ROLES.FRANCHISEE,
];

export const dashboardScreenRoles: string[] = [USER_ROLES.RESTAURANT_MANAGER, USER_ROLES.MARKETING, USER_ROLES.FOODICS_PARTNER];

export const crmScreenRoles: string[] = [USER_ROLES.RESTAURANT_MANAGER, USER_ROLES.MARKETING, USER_ROLES.CALL_CENTER_AGENT, USER_ROLES.CUSOMER_CARE];
